import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'accountPermission'
})
export class AccountPermissionPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return null;
  }

}



// WEBPACK FOOTER //
// D:/Git/MSPC_CP/02_CloudServer/10_GIGAENERGY_Server/web/src/app/account-permission.pipe.ts